import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { REPORT_CONFIG } from './index';

const SummaryTable = ({ data, reportName, QuarterID }) => {
    const config = REPORT_CONFIG[reportName];
    if (!config || !data || data.length === 0) return null;

    const isQuarterly = config.hasQuarterFilter;

    return (
        <div className="dashboard-table-container shadow-sm animate-fade-in">
            {/* Header section with optional Quarter Badge */}
            <div className="table-header-box d-flex align-items-center justify-content-between">
                <h6 className="mb-0 font-weight-bold">
                    <i className="fa fa-list-alt mr-2 text-info"></i>
                    {config.title} Detailed Summary
                </h6>
                {isQuarterly && QuarterID !== 0 && (
                    <Badge pill variant="primary" className="quarter-badge">
                        Quarter {QuarterID}
                    </Badge>
                )}
            </div>

            <Table responsive hover className="dashboard-table mb-0">
                <thead>
                    <tr>
                        {config.tableColumns.map((col, i) => (
                            <th key={i} className={col.isNumeric || col.isVariance || col.isPerformance ? "text-center" : "text-left"}>
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, ri) => (
                        <tr key={ri}>
                            {config.tableColumns.map((col, ci) => {
                                let val = row[col.key];
                                
                                // Fallback for differing API key names
                                if (col.key === "Values" && (val === undefined || val === null)) {
                                    val = row["Category"];
                                }
                                
                                const isNum = col.isNumeric || col.isVariance || col.isPerformance;
                                
                                // Determine styling for variances and performance
                                let statusClass = "";
                                if (col.isPerformance) {
                                    statusClass = val >= 100 ? "text-success font-weight-bold" : "text-danger";
                                } else if (col.isVariance) {
                                    statusClass = val >= 0 ? "text-success" : "text-danger";
                                }

                                return (
                                    <td key={ci} className={`${isNum ? "text-center" : "text-left"} ${statusClass}`}>
                                        {typeof val === 'number' 
                                            ? (col.isPerformance ? val.toFixed(1) : val.toLocaleString()) 
                                            : (val || "N/A")}
                                        {col.isPerformance && "%"}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default SummaryTable;